<template>
  <div>
    <title>发货商品盘点</title>
    <section class="mainPart">
      <!--S 检索-->      
      <el-form :inline="true" :model="deliveryedForm">
          <el-form-item label="关键词">
            <el-input clearable v-model="deliveryedForm.keyword" placeholder="请输入商品/规格名称"></el-input>
          </el-form-item>
          <el-form-item label="商品分类">
            <GoodsClassSelect @classObtain="calssReceive"></GoodsClassSelect>
          </el-form-item>
          <!-- <el-form-item label="发货方">
            <el-select v-model="deliveryedForm.flowcode" filterable clearable placeholder="请选择或输入" :filter-method="filterFlow" @focus="closeFlowName">
              <div class="optionBox">
                <el-option
                  v-for="item in flowList"
                  :key="item.flowcode"
                  :label="item.flowname"
                  :value="item.flowcode">
                </el-option>
              </div>
              <el-pagination
                @current-change="flowCurrentChange"
                :current-page="flowCurrent"
                :page-sizes="[10]"
                :page-size="10"
                layout="pager"
                :total="flowBean.totalnum" v-show="flowBean.totalnum"
                small>
              </el-pagination>
            </el-select>
          </el-form-item>  -->
          <el-form-item label="配送方式">
            <el-select v-model="deliveryedForm.deliverytype" class="formTimeSlot" @change="querySubmit()" clearable>
              <el-option label="送货" :value="1"></el-option>
              <el-option label="自提" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间">
            <!-- S 双日期选择器 -->
            <TwoDatePicker
              @twoDateObtain="outDateReceive"
              :startvaldate="deliveryedForm.outTime.length>0?deliveryedForm.outTime[0]:''"
              :endvaldate="deliveryedForm.outTime.length>0?deliveryedForm.outTime[1]:''"
              key="out">
            </TwoDatePicker>
            <!-- E 双日期选择器 -->
          </el-form-item>
          <el-form-item :label="deliveryedForm.deliverytype===1?'发货时间':(deliveryedForm.deliverytype===0?'自提时间':'发货/自提时间')">
            <!-- S 双日期选择器 -->
            <TwoDatePicker
              @twoDateObtain="expectDateReceive"
              :startvaldate="deliveryedForm.expectTime.length>0?deliveryedForm.expectTime[0]:''"
              :endvaldate="deliveryedForm.expectTime.length>0?deliveryedForm.expectTime[1]:''"
              key="expectTime">
            </TwoDatePicker>
            <!-- E 双日期选择器 -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="querySubmit">查询</el-button>
            <el-button type="primary" plain @click="exportGoodsDeliveryList">导出</el-button>
          </el-form-item>  
          <el-form-item>
            <span class="breathTit iconbulb orangeColor">默认查询发货/自提时间为当天的数据，不包含补发订单的统计</span>
          </el-form-item>  
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <!-- <div class="gsListTable individualiz" v-loading="loading">
        <el-form :model="deliveryedForm" inline size="medium">
          <el-form-item class="borderline borderNone">
            <em class="greyColor">配送方式</em>
            <el-checkbox-group v-model="deliveryedForm.deliverytype" @change="typeUpdate">
              <el-checkbox v-for="(item,index) of deliveryModeLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>                           
        </el-form> -->
        <el-table class="comTable orderTable" ref="gsTable" :data="deliveryData" border :maxHeight="tableHeight">
          <el-table-column label="序号" type="index" fixed prop="serial"></el-table-column>
          <el-table-column label="商品分类" prop="categorycode" fixed sortable min-width="180">
            <template slot-scope="scope">
              <div class="pdr70">
                <p class="textFl" :title="scope.row.categoryname">{{scope.row.categoryname}}</p>
                <small class="textFl" :title="scope.row.tcategoryname" v-if="bopentclassify==1">{{scope.row.tcategoryname}}</small>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品信息" min-width="250">
            <template slot-scope="scope">
              <p class="textFl pdr70" :title="scope.row.goodsname">{{scope.row.goodsname}}</p>
            </template>
          </el-table-column>
          <el-table-column label="规格名称" prop="kindinfo" sortable min-width="300">
            <template slot-scope="scope">
              <p class="textFl pdr70" :title="scope.row.kindinfo">{{scope.row.kindinfo}}</p>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="totalnum" sortable min-width="240">
            <template slot-scope="scope">
             <span :title="scope.row.totalnum">{{scope.row.totalnum}}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="noData">
              <span>暂无数据</span>
            </div>
          </template>
        </el-table>
      <!-- </div> -->
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
    </section>
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
  name: 'CheckDeliveryedGoods',
  data () {
    return {
      //检索
      deliveryedForm: {
        keyword: "", //关键词
        flowcode:"",//门店编号
        expectTime:[new Date(),new Date()], // 期望发货/自提时间
        outTime:[], // 下单时间
        categorycode:"",// 一级分类编号
        tcategorycode: '', // 二级分类编号
        deliverytype:1,//配送方式
      },
      flowList:[],//门店列表
      queryFlowname: '', // 检索的流向名称
      flowCurrent: 1, // 请求的商品的页面
      flowBean: { // 返回的商品分页信息
          totalnum: 0,
      },
      deliveryModeLists: [
        { label: "送货", value: 1 },
        { label: "自提", value: 0 }
      ], //配送方式列表
      bopentclassify: 0, //是否开通二级分类权限
      tableHeight: window.innerHeight*.8, //表格动态高度
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      deliveryData: [], // 获取到的商品列表
      firstTrue: true, // 防止多次点击
      loading: false, // 加载中弹窗显示和隐藏
    }
  },
  filters: {

  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
    GoodsClassSelect: resolve => require(["@/components/common/GoodsClassSelect.vue"], resolve), // 商品分类下拉组件
    TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
  },
  methods: {
    // 获取流向方列表
    getFlowList(size) {
      let flowParams = {
        objtypes: [0,1],
        isShowSelf: 1,
        keyword: this.queryFlowname,
        pageparam: {
          pagesize: size?size:30, //每页条数
          currentpage: this.flowCurrent, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      api.GET_LISTFLOWINFO(flowParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.flowList = res.data.data;
          } else {
            this.flowList = [];
          }
          this.flowBean = res.data.pagebean;
        }
      })
    },
    // 规格分页
    flowCurrentChange(val) {
        this.flowCurrent = val;
        this.getFlowList();
    },
    // 搜索规格方法
    filterFlow(item) {
        this.queryFlowname = item;
        this.flowCurrent = 1;
        this.getFlowList();
    },
    // 清除筛选的名称
    closeFlowName() {
        this.queryFlowname = '';
        this.flowCurrent = 1;
        this.getFlowList();
    },
    // 商品状态检索
    typeUpdate(val) {
      if(val.length>1) {
        val.splice(0,1)
      }
      this.querySubmit()
    },
    // 商品分类下拉框取值
    calssReceive(value) {
      if(value.length>0) {
        if(value.length ==2) {
          this.deliveryedForm.categorycode = value[0];
          this.deliveryedForm.tcategorycode = value[1];
        } else {
          this.deliveryedForm.categorycode = value[0];
        }
      } else {
        this.deliveryedForm.categorycode = '';
        this.deliveryedForm.tcategorycode = '';
      }
    },
    // 接收选中的期望发货日期
    expectDateReceive(info) {
      if(info&&info.length>0) {
        this.deliveryedForm.expectTime[0] = info[0];
        this.deliveryedForm.expectTime[1] = info[1];
      } else {
        this.deliveryedForm.expectTime = [];
      }
    },
    // 接收选中的出库日期
    outDateReceive(info) {
      if(info&&info.length>0) {
        this.deliveryedForm.outTime[0] = info[0];
        this.deliveryedForm.outTime[1] = info[1];
      } else {
        this.deliveryedForm.outTime = [];
      }
    },
    // 获取商品列表
    getGoodsDeliveryList() {
      this.loading = true;
      let goodsParam = {
        flowcode: this.deliveryedForm.flowcode,
        keyword: this.deliveryedForm.keyword, // 关键字
        categorycode: this.deliveryedForm.categorycode, // 商品分类编号
        tcategorycode: this.deliveryedForm.tcategorycode, // 二级商品分类编号
        delimode: this.deliveryedForm.deliverytype!==''?this.deliveryedForm.deliverytype:null, //送货方式,0：自提；1：送货；
        recvstartdate: this.deliveryedForm.expectTime.length>0?this.dateTime(this.deliveryedForm.expectTime[0]):'', //期望发货/自提预约
        recvenddate: this.deliveryedForm.expectTime.length>0?this.dateTime(this.deliveryedForm.expectTime[1]):'', //期望发货/自提预约
        submitstartdate: this.deliveryedForm.outTime.length>0?this.dateTime(this.deliveryedForm.outTime[0]):'', // 下单时间
        submitenddate: this.deliveryedForm.outTime.length>0?this.dateTime(this.deliveryedForm.outTime[1]):'', // 下单时间
        pageparam: {
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      };
      api.GET_GOODSDELIVERYLIST(goodsParam).then(res => {
        this.toTableTop('gsTable');
        if(res.data.status == "200") {
          this.deliveryData = res.data.data;
          this.pagebBean = res.data.pagebean;
          //在dom渲染之后
          if(!this.heightTrue) {
            setTimeout(()=>{
              this.getHeight();
              this.heightTrue = true;
            },500);
          }
        }else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      })
    },
    // 查询确定事件
    querySubmit(val) {
      this.currentPage = 1;
      this.getGoodsDeliveryList();
    },
    // 接收分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.goodsStatus = false;
      this.getGoodsDeliveryList();
    },
    // 导出实物商品数量统计列表
    exportGoodsDeliveryList() {
      if(this.firstTrue) {
        let exportParams = {
          flowcode: this.deliveryedForm.flowcode,
          keyword: this.deliveryedForm.keyword, // 关键字
          categorycode: this.deliveryedForm.categorycode, // 商品分类编号
          tcategorycode: this.deliveryedForm.tcategorycode, // 二级商品分类编号
          delimode: this.deliveryedForm.deliverytype!==''?this.deliveryedForm.deliverytype:null, //送货方式,0：自提；1：送货；
          recvstartdate: this.deliveryedForm.expectTime.length>0?this.dateTime(this.deliveryedForm.expectTime[0]):'', //期望发货/自提预约
          recvenddate: this.deliveryedForm.expectTime.length>0?this.dateTime(this.deliveryedForm.expectTime[1]):'', //期望发货/自提预约
          submitstartdate: this.deliveryedForm.outTime.length>0?this.dateTime(this.deliveryedForm.outTime[0]):'', // 下单时间
          submitenddate: this.deliveryedForm.outTime.length>0?this.dateTime(this.deliveryedForm.outTime[1]):'', // 下单时间
        }
        this.firstTrue = false;
        this.loading = true;
        api.EXPORTGOODSDELIVERYLIST(exportParams).then(res => {
          if(res.data.status == "200") {
            window.location.href = res.data.data;
            this.$message({
              type: 'success',
              message: res.data.message
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
          this.firstTrue = true;
          this.loading = false;
        }).catch(res => {
          this.firstTrue = true;
          this.loading = false;
        })
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    // 获取公共服务基础配置
    if(localStorage.getItem('pubconfiginfo')&&localStorage.getItem('pubconfiginfo')!='null'&&localStorage.getItem('pubconfiginfo')!=undefined) {
      let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
      this.bopentclassify = pubConfigInfo.bopentclassify;
    }
    // 获取商品列表
    this.getGoodsDeliveryList();
    setTimeout(() => {
      this.deliveryedForm.expectTime = [];
    }, 0);
    //在dom渲染之后
    setTimeout(()=>{
      this.deliveryedForm.expectTime = [new Date(),new Date()];
      this.getHeight();
    },300)
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pdr70 {padding-right:70px;width:auto;display: block;}
.creditIcon em{
    display: block;
    color: #333;
    font-size: 14px;
    margin: 5px 0;
}
.creditIcon em i{
    display: inline-block;
    height: 20px;
    width: 20px;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
}
.creditIcon em .remainIcon{
    background: #f56262;
}
.creditIcon em .usedIcon{
    background: #f2962c;
}
.creditIcon em .totalIcon{
    background: var(--main-color);
}
.creditIcon em strong{
    min-width: 80px;
    text-align: left;
    display: inline-block;
    font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/views/StatisticsFolder/CheckDeliveryedGoods.vue